import React from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import * as Yup from "yup";
import { AssetFeatureDetailDto } from "src/store/asset-features/type";
import { addDamageDefinitionPicklistOption } from "src/store/contract-damage-definition/saga";
import { DamageDefinitionDetailDto } from "src/store/contract-damage-definition/type";

const DamageOptionCreateForm = ({
  onHide,
  open,
  onSuccessClick,
  definition,
}: {
  definition: DamageDefinitionDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  return (
    <React.Fragment>
      <FormDrawer
        drawerProps={{
          isOpen: open,
          onHide: onHide,
          title: t("Contract.DamageOption.CreateFormTitle").toString(),
        }}
        onHide={onHide}
        loader
        initialValues={{
          PicklistOptionName: "",
          DamageDefinitionId: definition.Id,
          Translates: languages.map((x) => {
            return { LanguageId: x.EnumId, PicklistOptionName: "" };
          }),
        }}
        onSubmit={(values) => {
          dispatch(
            addDamageDefinitionPicklistOption({
              payload: {
                onSuccess: (message, payload) => {
                  onHide();
                  onSuccessClick(message);
                },
                onError: (message) => {
                  toast.error(message, {
                    theme: "colored",
                  });
                },
              },
              body: values,
            })
          );
        }}
        validationSchema={Yup.object().shape({
          PicklistOptionName: Yup.string().required(
            t("Validation.Required").toString()
          ),
          DamageDefinitionId: Yup.string().required(
            t("Validation.Required").toString()
          ),
          Translates: Yup.array(
            Yup.object({
              PicklistOptionName: Yup.string().required(
                t("Validation.Required").toString()
              ),
            })
          ),
        })}
        multilanguageinputs={[
          {
            field: "PicklistOptionName",
            label: t("Contract.DamageOption.OptionName").toString(),
          },
        ]}
      />
    </React.Fragment>
  );
};
export default DamageOptionCreateForm;
